// extracted by mini-css-extract-plugin
export default {"fallback__btn":"r4JM7"};